import { v4 as uuidv4 } from 'uuid';
import React, { useReducer } from 'react';
import { IAdLoop as Ad } from './requests';

export enum StrapiComponentType {
  News = 'news',
  Weather = 'weather',
}

export type Actions =
    { type: 'SET_LOADING' } |
    { type: 'SET_ERROR' } |
    { type: 'TOGGLE_LOADING', payload: boolean } |
    { type: 'SET_AD', payload: Ad } |
    { type: 'SET_COMPONENT', payload: StrapiComponentType };

export const adsInitialState = {
  uuid: uuidv4(),
  loading: false,
  error: false,
  ad: null as unknown as Ad,
  component: null as unknown as StrapiComponentType,
  isActive: true,
};

export const adsReducer = (state = adsInitialState, action: Actions): typeof adsInitialState => {
  switch (action.type) {
    case 'SET_LOADING': {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case 'SET_ERROR': {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case 'TOGGLE_LOADING': {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case 'SET_AD': {
      return {
        ...state,
        component: null as unknown as StrapiComponentType,
        ad: action.payload,
        uuid: uuidv4(),
      };
    }
    case 'SET_COMPONENT': {
      return {
        ...state,
        component: action.payload,
        ad: null as unknown as Ad,
        uuid: uuidv4(),
      };
    }
    default: {
      return state;
    }
  }
};

type UseAdLoopReducerReturnType = [typeof adsInitialState, React.Dispatch<Actions>];
export const useAdLoopReducer = ():UseAdLoopReducerReturnType => useReducer(adsReducer, adsInitialState);
